import { useCallback, useState } from "react";

export interface LightboxImage {
  src: string;
  alt: string;
  title: string;
}

export const useImageLightbox = (items: LightboxImage[]) => {
  const [index, setIndex] = useState<number | null>(null);

  const open = useCallback(
    (nextIndex: number) => {
      if (nextIndex < 0 || nextIndex >= items.length) {
        return;
      }
      setIndex(nextIndex);
    },
    [items.length],
  );

  const close = useCallback(() => {
    setIndex(null);
  }, []);

  const showPrev = useCallback(() => {
    setIndex((current) => {
      if (current == null || items.length === 0) {
        return current;
      }
      return (current - 1 + items.length) % items.length;
    });
  }, [items.length]);

  const showNext = useCallback(() => {
    setIndex((current) => {
      if (current == null || items.length === 0) {
        return current;
      }
      return (current + 1) % items.length;
    });
  }, [items.length]);

  const isOpen = index != null;
  const activeItem = index != null ? items[index] : null;

  return {
    index,
    isOpen,
    activeItem,
    open,
    close,
    showPrev,
    showNext,
    hasPrev: items.length > 1,
    hasNext: items.length > 1,
  };
};
